import React, { FC } from "react";

import { Check, ReportProblem } from "@mui/icons-material";
import { InputAdornment, Tooltip } from "@mui/material";

type TextFieldValidationAdornmentProps = {
  error?: string;
};
const TextFieldValidationAdornment: FC<TextFieldValidationAdornmentProps> = ({
  error,
}) => {
  return (
    <InputAdornment position="end">
      {error ? (
        <Tooltip title={error}>
          <ReportProblem
            sx={(theme) => ({
              cursor: "default",
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.warning.dark
                  : theme.palette.warning.light,
            })}
          />
        </Tooltip>
      ) : (
        <Check
          sx={(theme) => ({
            cursor: "default",
            color:
              theme.palette.mode === "dark"
                ? theme.palette.success.dark
                : theme.palette.success.light,
          })}
        />
      )}
    </InputAdornment>
  );
};
export default TextFieldValidationAdornment;
